import CompanyInfo from './container/index';

export default CompanyInfo;




// WEBPACK FOOTER //
// ./src/views/Setup/CompanyInfo/index.js